<script setup lang="ts">
import {computed} from "vue";

const props = withDefaults(
    defineProps<{
      time: number
    }>(),
    {
      time: 0
    }
)

const formattedTime = computed(() => {
  const totalSeconds = Number(props.time) || 0

  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0')
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0')
  const seconds = String(totalSeconds % 60).padStart(2, '0')

  return `${hours}:${minutes}:${seconds}`
})
</script>

<template>
  <div class="f-ui-reply-time" :class="time > 300 ? 'error' : ''">
    {{ formattedTime }}
  </div>
</template>

<style scoped lang="scss">
.f-ui-reply-time {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  font-weight: 600;
  padding: 4px 8px;
  border: 1px solid var(--color-border);
  display: inline-block;
  border-radius: 8px;

  &.error {
    background: var(--color-red-light);
    color: var(--color-red);
  }
}
</style>